import { render, staticRenderFns } from "./ProjectWordCloud.vue?vue&type=template&id=350bf01c&scoped=true&"
import script from "./ProjectWordCloud.vue?vue&type=script&lang=ts&"
export * from "./ProjectWordCloud.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectWordCloud.vue?vue&type=style&index=0&id=350bf01c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350bf01c",
  null
  
)

export default component.exports